import configureStore from './core/configureStore'; // _platform
import history from './history'; // _platform

const initialState = {};
const store = configureStore(initialState, history);
// Note: Store is exported in order to be used in utils/request

export default store;
